<template>
    <div id="detail">
        <PlayerArea :videoId.sync="videoId" :viewList.sync="viewList" :viewInfo.sync="videoInfo" :wxurl="''" />
        <InfoArea :briefArray="briefList" @transfer="toDetail" />
    </div>
</template>

<script>
import PlayerArea from "../Common/PlayerArea";
import InfoArea from "../Common/InfoArea";

export default {
    name: "VideoDetail",
    data() {
        return {
            briefList: [],
            viewList: [],
            videoInfo: {},
            videoId: ""
        };
    },
    components: { PlayerArea, InfoArea },
    created() {
        let param = this.$route.params.gId || this.$route.params.gid;
        param && sessionStorage.setItem("v-gid", param);
        let gid = param || this.$route.query.gid || this.$route.query.gId || sessionStorage.getItem("v-gid");
        
        this.getVideoDetail(gid);

        // console.log("this.gid", this.gid)

    },
    mounted() {},
    methods: {
        getVideoDetail(gid) {
            this.$axios
                .post("/web/course/querySingleVideoDetail", this.$qs.stringify({ gid }))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        let dtArr = data.result_data;
                        this.videoId = dtArr.videoId;
                        this.briefList = dtArr.expert;
                        let infoArr = {
                            avatar: dtArr.avatar,
                            coureTitle: dtArr.introduction,
                            title: dtArr.title,
                            videoId: dtArr.videoId,
                            watchNum: sessionStorage.getItem("w-num"),
                            logined:dtArr.logined,
                        };
                        this.viewList.push(infoArr);
                        this.videoInfo = infoArr;
                    } else {
                        this.$message.error(data.message);
                    }
                })
                .catch(err => {
                });
        },
        toDetail(dic) {
            this.$router.push({ path: "/classVideo", params: { gid: dic }, query: { gid: dic }});
        }
    }
};
</script>

<style scoped>
#detail {
    margin: 0 auto;
    padding-top: 30px;
    width: 1200px;
    height: auto;
}
</style>
